import { useMemo, useState } from 'react';
import { calculateRuntimeDasha, getDashaCycleInfo } from '../utils/dashaCalculator';

/** Keeps only the selected 120-year cycle in memory; chart changes reset the choice. */
export const useDashaCycles = (chart: any, asOfDate?: Date) => {
  // Refresh today when a new chart is loaded, even without an explicit transit date.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const referenceDate = useMemo(() => asOfDate || new Date(), [chart, asOfDate]);
  const info = useMemo(() => getDashaCycleInfo(chart, referenceDate), [chart, referenceDate]);
  const [choice, setChoice] = useState<{ chart: any; referenceDate: Date; cycle: number } | null>(null);
  const cycleNumber = choice && choice.chart === chart && choice.referenceDate === referenceDate ? choice.cycle : info?.currentCycle;
  const timeline = useMemo(() => calculateRuntimeDasha(chart, referenceDate, cycleNumber), [chart, referenceDate, cycleNumber]);
  const setCycle = (cycle: number) => {
    if (getDashaCycleInfo(chart, referenceDate, cycle)) setChoice({ chart, referenceDate, cycle });
  };
  // Visibility follows the chart's age today, including when exploring a transit date.
  const showCycleSelector = useMemo(() => getDashaCycleInfo(chart)?.showCycleSelector || false, [chart]);
  return { timeline, setCycle, showCycleSelector, currentCycle: info?.currentCycle || 1 };
};
export type DashaCycles = ReturnType<typeof useDashaCycles>;
